import { render, staticRenderFns } from "./TaskSelectView.vue?vue&type=template&id=6b2ead08&scoped=true&"
import script from "./TaskSelectView.vue?vue&type=script&lang=js&"
export * from "./TaskSelectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2ead08",
  null
  
)

export default component.exports